import { http } from '../../http';
import { useCustomConfig } from '@/js/composables/useCustomAxiosRequestConfig';
import type { SyncJob } from './types';
import type { AsrChannelType } from './asrConfigApi';

export type EnqueuedAsrFullAnalysisJob = {
    interactionPartExternalId: string;
    jobId: number;
};

export type EnqueueAsrFullAnalysisResponse = {
    enqueued: EnqueuedAsrFullAnalysisJob[];
    notEligible: string[];
    notFound: string[];
    alreadyQueued: string[];
};

export const enqueueAsrFullAnalysis = async (
    tenantId: string,
    interactionPartExternalIds: string[]
): Promise<EnqueueAsrFullAnalysisResponse> => {
    return http
        .backoffice()
        .post<EnqueueAsrFullAnalysisResponse>(
            `asr-enqueue/${tenantId}/full-analysis`,
            { interactionPartExternalIds },
            useCustomConfig({ silent: true })
        )
        .then((response) => response.data);
};

export const sendInteractionsForAnalysisByInterval = async (
    tenantId: string,
    start: string,
    end: string,
    reanalyzeAlreadyAnalyzed: boolean,
    channelIds: string[] | null,
    channelTypes: AsrChannelType[] | null
): Promise<{ id: string }> => {
    return http
        .backoffice()
        .post<{ id: number }>(
            `asr-enqueue/${tenantId}/full-analysis/interval`,
            { start, end, reanalyzeAlreadyAnalyzed, channelIds, channelTypes },
            useCustomConfig({ silent: true })
        )
        .then((response) => ({ id: String(response.data.id) }));
};

export const getIntervalAnalysisJobs = async (): Promise<SyncJob[]> => {
    return http
        .backoffice()
        .get<SyncJob[]>('asr-enqueue/interval-jobs')
        .then((response) => response.data);
};

export type AsrJobStatus = 'Queued' | 'Running' | 'Succeeded' | 'Failed';

export type AsrJobStatusEntry = {
    id: number;
    interactionPartExternalId: string;
    status: AsrJobStatus;
    priority: number;
    workerId: string;
    createdAt: string;
    startedAt: string | null;
    endedAt: string | null;
    output: string;
};

export const getAsrJobs = async (tenantId: string): Promise<AsrJobStatusEntry[]> => {
    return http
        .backoffice()
        .get<AsrJobStatusEntry[]>(`asr-enqueue/${tenantId}/jobs`)
        .then((response) => response.data);
};
